import React from 'react';
import { formatDistanceToNow } from 'date-fns';

export const ConversationStats = ({ lastMessageAt, unreadCount, status }) => {
  return (
    <div className="flex flex-col items-end gap-1.5 ml-3 flex-shrink-0">
      {lastMessageAt && (
        <span className="text-[11px] font-medium text-gray-500 whitespace-nowrap">
          {formatDistanceToNow(new Date(lastMessageAt), { addSuffix: true })}
        </span>
      )}
      
      <div className="flex items-center gap-1.5">
        {status && (
          <span className={`w-2 h-2 rounded-full ${status === 'open' ? 'bg-green-500' : 'bg-gray-300'}`} title={`Status: ${status}`} />
        )}
        
        {unreadCount > 0 && (
          <span className="bg-purple-600 text-white text-[10px] font-bold px-2 py-0.5 rounded-full min-w-[20px] text-center shadow-sm">
            {unreadCount}
          </span>
        )}
      </div>
    </div>
  );
};
